import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCommentReply, editCommentReply, fetchComments } from "../../../redux/actions/comments";
import { hideModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import { UserComment } from "../../../redux/types";
import CommentDetail from "../../comments/comment-detail";
import CommentTagCard from "../../comments/comment-tag-card";
import Button from "../button";
import Textarea from "../form/textarea";
import ModalTemplate from "./template";
import { fetchOffices } from "../../../redux/actions/offices";

const CommentResponseModal = () => {
  const modalData = useSelector((state: State) => state.modals);
  const comment: UserComment = modalData.data?.comment;
  const doctorId = modalData.data.doctorId;
  const filter = modalData.data.selectedFilter;

  const [notes, setNotes] = useState("");
  const [error, setError] = useState<string>();
  const dispatch = useDispatch();

  useEffect(() => {
    setNotes(comment.reply_count > 0 ? comment.reply[0].body : "");
  }, [comment]);

  const hide = () => {
    setError("");
    setNotes("");
    dispatch(hideModal());
  };

  const submitReply = async () => {
    if (notes.trim().length === 0) {
      setError("نوشتن پاسخ ضروری است.");
    } else {
      comment.reply_count > 0
        ? await dispatch(editCommentReply(comment.reply[0].id, notes))
        : await dispatch(addCommentReply({ model: "Doctor", modelId: doctorId, body: notes, parent: comment.id }));
      hide();
      await dispatch(fetchOffices());
      if (filter === "needFollowUp") {
        await dispatch(fetchComments(doctorId, { status: "needFollowUp" }));
      }
    }
  };

  return (
    <ModalTemplate title="پاسخ به نظر کاربر" icon="fa fa-reply">
      <hr className="mt-3" />
      <div className="px-2">
        <CommentDetail comment={comment} showDayOfWeek={true} replying={true} />
        {comment.tag?.length > 0 && <CommentTagCard comment={comment} />}
      </div>
      <hr className="my-3" />
      <div className="flex flex-col mb-5">
        <Textarea
          label="پاسخ"
          labelClassName="font-medium text-pkc-form-text pr-2"
          onChange={(e) => setNotes(e.currentTarget.value)}
          placeholder="متن توضیحات خود را وارد نمایید"
          value={notes}
          className="h-32 shadow-none bg-pkc-pale-grey border-pkc-disable lg:scrollbar focus:outline-none focus:bg-white"
        />
        {error !== "" && <p className="mt-1 ml-2 text-left text-red-500">{error}</p>}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <Button className="w-full" variant="outline" onClick={hide}>
          انصراف
        </Button>

        <Button className="w-full" onClick={submitReply}>
          ثبت پاسخ
        </Button>
      </div>
    </ModalTemplate>
  );
};

export default CommentResponseModal;
